import { observer }    from 'mobx-react-lite';
import ZoneCountButton from '@/TokamapEditor/ux/ZoneCountButton';

const PlacesWithoutShapeButton = observer(() => (
	<ZoneCountButton
		filter={shape => (
			shape.shapeKind !== 'image'
			&& (
				shape.action !== 'open_place'
				|| !shape.entity
			)
		)}
		suffix={count => `non associée${count > 1 ? 's' : ''}`}
	/>
));

export default PlacesWithoutShapeButton;
